import { useMemo } from 'react';
import { CurrentPopupContext } from './context';
import Popup from './Popup/Popup';
import { PopupApi, PopupPlacementType, PopupProps } from './Popup/type';

type PopupComponent<c> = {
  (props: PopupProps<c>): JSX.Element;
  api?: PopupApi<c>;
};

export default function useCreatePopupProvider<c>(
  api: PopupApi<c>,
  id: string,
  type: 'modal' | 'dropdown' = 'dropdown',
) {
  let placement: PopupPlacementType = 'bottom-end';
  let overlay = false;

  if (type === 'modal') {
    placement = 'screen-centered';
    overlay = true;
  }

  const component: PopupComponent<c> = useMemo(() => {
    return function (props: PopupProps<c>) {
      if (!component.api) return <></>;

      return (
        <CurrentPopupContext.Provider value={component.api}>
          <Popup overlay={overlay} placement={placement} {...props} id={id} />
        </CurrentPopupContext.Provider>
      );
    };
  }, []);

  component.api = api;
  return component;
}
